import {INSTRUMENT} from 'constants/track-types.js';

/**
 * Defines how a parameter is to be found, i.e. what track/group/send
 * and/or effect it relates to. Can be serialized and deserialized, so
 * upon reloading, can reconstruct find the parameter in the system
**/

class ParameterContext {
    constructor() {
    }

    getCopy() {
        let context = new ParameterContext();
        context.sequencerEngine = this.sequencerEngine;
        context.envelopesTrack = this.envelopesTrack;
        context.envelopeTrack = this.envelopeTrack;
        context.lfosTrack = this.lfosTrack;
        context.lfoTrack = this.lfoTrack;
        context.liveEffect = this.liveEffect;
        context.track = this.track;
        context.group = this.group;
        context.instrument = this.instrument;
        context.send = this.effect;
        context.effect = this.effect;
        context.midiEffect = this.midiEffect;
        context.subDevice = this.subDevice;
        context.macro = this.macro;
        context.formant = this.formant;
        context.oscillator = this.oscillator;
        context._subSequence = this._subSequence;
        context.zObject = this.zObject;
        return context;
    }
    
    forZObject(z) {
        this.zObject = z;
        return this;
    }
    
    forSequencerEngine(sequencerEngine) {
        this.sequencerEngine = sequencerEngine;
        return this;
    }

    get subSequence() {
        if (this._subSequence) {
            return this._subSequence;
        }

        if (this.envelopesTrack !== undefined) {
            return this.envelopesTrack.subSequence;
        }

        if (this.lfosTrack !== undefined) {
            return this.lfosTrack.subSequence;
        }

        if (this.track !== undefined) {
            return this.track.subSequence;
        }

        return undefined;
    }

    forEnvelopeTrack(envelopeTrack, envelopesTrack) {
        this.envelopeTrack = envelopeTrack;
        this.envelopesTrack = envelopesTrack;
        return this;
    }

    forLFOTrack(lfoTrack, lfosTrack) {
        this.lfoTrack = lfoTrack;
        this.lfosTrack = lfosTrack;
        return this;
    }

    forMacro(macro) {
        this.macro = macro;
        return this;
    }

    forTrack(track) {
        this.track = track;
        return this;
    }

    forGroup(group) {
        this.group = group;
        return this;
    }

    forSend(send) {
        this.send = send;
        return this;
    }

    forEffect(effect) {
        this.effect = effect;
        return this;
    }

    forMidiEffect(effect) {
        this.midiEffect = effect;
        return this;
    }

    forLiveEffect(effect) {
        this.liveEffect = effect;
        return this;
    }

    forInstrument(instrument) {
        this.instrument = instrument;
        return this;
    }

    forSubSequence(sub) {
        this._subSequence = sub;
        return this;
    }


    forOscillator(oscillator) {
        this.oscillator = oscillator;
        return this;
    }

    forSubDevice(subDevice) {
        this.subDevice = subDevice;
        return this;
    }

    forFormant(formant) {
        this.formant = formant;
        return this;
    }

    // returns the track, group, or send associated with the effect
    getEffectContext() {
        return this.track !== undefined ? this.track :
            this.group !== undefined ? this.group :
            this.send !== undefined ? this.send : undefined;
    }

    getJson() {
        let json = {};
        let effects = [];

        if (this.track !== undefined && this.track.getTrackType && this.track.getTrackType() === INSTRUMENT) {
            json = {
                ... json,
                track: this.track.trackNumber,
                isInstrument: true,
            };
        }

        if (this.track !== undefined) {
            effects = this.track.effects;
            json.track = this.track.trackNumber;
        } else if (this.group !== undefined) {
            effects = this.group.effects;
            json.group = this.group.groupNumber;
        } else if (this.send !== undefined) {
            effects = this.send.effects;
            json.send = this.send.sendNumber;
        } 

        json.effect = -1;
        // now find the effect number
        if (this.effect) {
            if (effects) {
                json.effect = effects.indexOf(this.effect);
                json.effectName = this.effect.name;
            }
            if (this.subDevice && this.effect.getSubDeviceIndex) {
                json.subDevice = this.effect.getSubDeviceIndex(this.subDevice);
            }
        }

        if (this.midiEffect && this.track && this.track.midiEffects) {
            json.midiEffect = this.track.midiEffects.effects.indexOf(this.midiEffect);
            json.midiEffectName = this.midiEffect.name;
        }

        if (this.liveEffect) {
            json.liveEffect = this.track.liveEffects.effects.indexOf(this.liveEffect);
            json.liveEffectName = json.liveEffect.name;
        }

        if (this.macro) {
            json.macro = this.macro.id;
        }

        if (this.instrument) {
            json.isInstrument = true;
            let subDevice = undefined;
            if (this.subDevice) {
                subDevice = this.track.instrument.getSubDeviceIndex(this.subDevice);
            }
            json.subDevice = subDevice;
            json.instrumentType = this.instrument.getInstrumentType && this.instrument.getInstrumentType();
        }

        return json;
    }

    combineWith(context) {
        if (context.track) {
            this.track = context.track;
        }
        if (context.effect) {
            this.effect = context.effect;
        }
        if (context.subDevice) {
            this.subDevice = context.subDevice;
        }
        if (context.send) {
            this.send = context.send;
        }
        if (context._subSequence) {
            this._subSequence = context._subSequence;
        }
        return this;
    }
}

export default ParameterContext;
